<mat-toolbar color="primary" *ngIf="domain !== 'schoolinfo.browardschools.com'">
  <a class="title" href="/schoolboardpolicy">{{ title }}</a>

  <div class="toolbar-spacer"></div>

  <!-- <a mat-button [routerLink]="['softwarelist']">Software List</a> -->
  <!-- <a mat-button [routerLink]="['profile']">Profile</a> -->
  <a mat-button [routerLink]="['policies']">Policies</a>
  <!-- <a mat-button [routerLink]="['boardpolicies']">Board Policies</a> -->
  <a *ngIf="userType === 'Admin' || userType === 'User'" mat-button [routerLink]="['policymanagement']">Policy Management</a>
  <a *ngIf="userType === 'Admin'" mat-button [routerLink]="['category']">Category</a>
  <a *ngIf="userType === 'Admin'" mat-button [routerLink]="['principal']">Principal</a>
  <a *ngIf="userType === 'Admin'" mat-button [routerLink]="['user']">User Management</a>

  <button mat-raised-button *ngIf="!loginDisplay" (click)="login()">Login</button>
  <button mat-raised-button *ngIf="loginDisplay" (click)="logout()">Logout</button>


</mat-toolbar>
<!-- <p style="margin: 10px 10px 10px 10px;" *ngIf="currentUserInfo?.userName">{{currentUserInfo?.userName}}, Welcom to Schoolboard Policies Information Website</p> -->

<div class="container">
  <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
  <router-outlet></router-outlet>
</div>